import { render, staticRenderFns } from "./VideoAudit.vue?vue&type=template&id=815b75e2&scoped=true"
import script from "./VideoAudit.vue?vue&type=script&lang=js"
export * from "./VideoAudit.vue?vue&type=script&lang=js"
import style0 from "./VideoAudit.vue?vue&type=style&index=0&id=815b75e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815b75e2",
  null
  
)

export default component.exports